interface ActiveSession {
  bookingId: string;
  endTime: number;  // booking end timestamp (ms)
  facility: string;
  location: string;
}

const STORAGE_KEY = 'activeSession';

export const sessionTimer = {
  startSession: (bookingId: string, endTime: number, facility: string, location: string) => {
    const session: ActiveSession = {
      bookingId,
      endTime,
      facility,
      location,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  },

  getActiveSession: (): ActiveSession | null => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return null;
    try {
      return JSON.parse(stored);
    } catch {
      return null;
    }
  },

  // Remaining time in ms = booking endTime - now
  getRemainingTime: (): number => {
    const session = sessionTimer.getActiveSession();
    if (!session) return 0;
    return Math.max(0, session.endTime - Date.now());
  },

  formatRemainingTime: (remainingMs: number): string => {
    if (remainingMs <= 0) return '0:00:00';
    const h = Math.floor(remainingMs / 3600000);
    const m = Math.floor((remainingMs % 3600000) / 60000);
    const s = Math.floor((remainingMs % 60000) / 1000);
    return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  },

  isSessionActive: (): boolean => {
    return sessionTimer.getRemainingTime() > 0;
  },

  endSession: () => {
    localStorage.removeItem(STORAGE_KEY);
  },

  getSessionProgress: (): number => {
    const session = sessionTimer.getActiveSession();
    if (!session) return 0;
    // Progress from check-in to end isn't trackable without startTime — use endTime proximity
    const remaining = session.endTime - Date.now();
    const total = session.endTime - (session.endTime - 3600000); // assume max 1h window for progress
    return Math.min(100, Math.max(0, (1 - remaining / total) * 100));
  },
};
